import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { Box, Button, Link, Modal } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import NotesSection from "../../../../../Components/Broker/NotesSection/NotesSection";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import PostQueryForm from "../../../../../Components/Common/PostQuerySP/PostQueryForm";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import RKTextFieldDisable from "../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
import SearchDropdownDisable from "../../../../../Supporting files/SearchDropdownDisable/SearchDropdownDisable";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import "../../../../../formLayout.scss";
function ClaimAssistantDetailEmployer() {
  const navigate = useNavigate();

  const [viewTabsStatus, setViewTabsStatus] = React.useState("overview");

  const [memberId, setMemberId] = React.useState("EV001- Uday Kumar");
  const [clientId, setclientId] = React.useState("EV001- Evervent");
  const [policyNumber, setpolicyNumber] = React.useState(
    "PB152412- Group Health"
  );
  const [hospital, setHospital] = useState("Fortis Hospital");
  const [country, setCountry] = React.useState("India");
  const [state, setState] = React.useState("Haryana");
  const [city, setCity] = React.useState("Chandigarh");
  const [department, setDepartment] = useState("Surgery");
  const [admissionDate, setAdmissionDate] = React.useState<Date | null>(null);
  const [dischargeDate, setDischargeDate] = React.useState<Date | null>(null);
  const [illness, setIllness] = useState("");
  const [claimamount, setClaimAmount] = useState("₹ 10,000");
  const [paidclaimamount, setPaidClaimAmount] = useState("");
  const [outstandingclaimamount, setOutstandingClaimAmount] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [bankName, setBankName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [remarks, setRemarks] = useState("");

  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);
  const [attachment, setAttachment] = React.useState(false);
  const [policyId, setpolicyId] = React.useState("PL1421");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [removeStatus, setRemoveStatus] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [priorityStatus, setPriorityStatus] = React.useState("Pending");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [subSection, setSubSection] = React.useState("memberdetails");
  const [postQueryForm, setPostQueryForm] = React.useState(false);

  const prioritystatusData = [
    { key: "Pending", value: "Pending" },
    { key: "Expired", value: "Expired" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
    { key: "Inprogress", value: "Inprogress" },
  ];

  // for scrolling
  const personalDetails = useRef(null);
  const hospitalDetails = useRef(null);
  const claimInfo = useRef(null);
  const attatchmentsdetails = useRef(null);
  //const ref = useRef(null);
  const memberdetails = useRef(null);
  const basicdetails = useRef(null);
  const claimdetails = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const updateMasterState = (attrName: any, value: any) => {
    if (attrName === "notes_new_data") {
      setNotesData((notesData) => [
        ...notesData,
        { name: "Umesh", date: new Date(), description: value },
      ]);
    } else {
      attrName(value);
    }
  };

  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];

  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];
  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];

  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homeemployer?page=claim");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <span className="detailIcon">C</span>
          <div>
            <h3>Claim Intimation</h3>
            <p>CLM 001520</p>
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          {/* <div>
            <Tooltip title="Remove">
              <Link
                
                underline="none"
                className="actionLinks red_icon"
                onClick={() => {
                  setRemoveStatus(true);
                }}
              >
                <DeleteOutlineIcon />
              </Link>
            </Tooltip>
          </div>
         
          <div>
            <Tooltip title="Global Edit">
              <Link className="actionLinks" onClick={() => {}}>
                <BorderColorIcon />
              </Link>
            </Tooltip>
          </div> */}
          {/* Status Dropdown */}
          <div id={priorityStatus}>
            <div className="status_dropdown" id={priorityStatus}>
              {priorityStatus === "Highest" || priorityStatus === "Active" ? (
                <CheckCircleIcon id={priorityStatus} />
              ) : priorityStatus == "" || priorityStatus === "Rejected" ? (
                <CancelIcon id={priorityStatus} />
              ) : priorityStatus == "Pending" ? (
                <HourglassTopIcon id={priorityStatus} />
              ) : priorityStatus == "Inprogress" ? (
                <PublishedWithChangesIcon id={priorityStatus} />
              ) : priorityStatus == "Expired" ? (
                <HistoryToggleOffIcon id={priorityStatus} />
              ) : null}
              <SelectDropdown
                class_name="inputFieldd"
                title=""
                value={priorityStatus}
                attrName={setPriorityStatus}
                value_update={updateMasterState}
                dropdown_data={prioritystatusData}
                warn_status={false}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "personalDetails"
                    ? "active sectionLink personalDetails"
                    : "sectionLink personalDetails"
                }
                onClick={() => {
                  scrollToSection(personalDetails);
                  SetSectionStatus("personalDetails");
                }}
              >
                <span> Member Info</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "memberdetails"
                        ? "inner_link active memberdetails"
                        : "inner_link memberdetails"
                    }
                    onClick={() => {
                      setSubSection("memberdetails");
                      handleClicks(subSection);
                      scrollToSection(memberdetails);
                    }}
                  >
                    Member & Policy Details
                  </Link>
                </li>
              </ul>
              <Link
                className={
                  sectionStatus === "hospitalDetails"
                    ? "active sectionLink hospitalDetails"
                    : "sectionLink hospitalDetails"
                }
                onClick={() => {
                  scrollToSection(hospitalDetails);
                  SetSectionStatus("hospitalDetails");
                }}
              >
                <span> Hospital Treatment</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "basicdetails"
                        ? "inner_link active basicdetails"
                        : "inner_link basicdetails"
                    }
                    onClick={() => {
                      setSubSection("basicdetails");
                      handleClicks(subSection);
                      scrollToSection(basicdetails);
                    }}
                  >
                    Basic Details
                  </Link>
                </li>
              </ul>
              <Link
                className={
                  sectionStatus === "claimInfo"
                    ? "active sectionLink claimInfo"
                    : "sectionLink claimInfo"
                }
                onClick={() => {
                  scrollToSection(claimInfo);
                  SetSectionStatus("claimInfo");
                }}
              >
                <span> Claim Info</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "claimdetails"
                        ? "inner_link active claimdetails"
                        : "inner_link claimdetails"
                    }
                    onClick={() => {
                      setSubSection("claimdetails");
                      handleClicks(subSection);
                      scrollToSection(claimdetails);
                    }}
                  >
                    Claim Details
                  </Link>
                </li>
              </ul>

              <Link
                className={
                  sectionStatus === "attatchmentsdetails"
                    ? "active sectionLink attatchmentsdetails"
                    : "sectionLink attatchmentsdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsdetails);
                  SetSectionStatus("attatchmentsdetails");
                }}
              >
                <span>Attatchments</span>
              </Link>
            </Grid>
            <Grid xs className="rightSection h-100">
              <Grid container spacing={3} alignItems="center">
                <Grid lg={7} md={7} xs={12} className="pl-0">
                  <div className="productTabs ">
                    <Button
                      className={
                        viewTabsStatus == "overview"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "overview");
                      }}
                    >
                      Overview
                    </Button>

                    <Button
                      className={
                        viewTabsStatus == "notes"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "notes");
                      }}
                    >
                      Notes
                    </Button>
                  </div>
                </Grid>
                <Grid
                  lg={5}
                  md={5}
                  xs={12}
                  style={{ textAlign: "right" }}
                  className="text-sm-center"
                >
                  <p className="lastupdate">
                    Last Update: 11:00AM, 10th Nov, 2022
                  </p>
                </Grid>
              </Grid>
              {viewTabsStatus == "overview" ? (
                <>
                  <Box className="detailSection" ref={personalDetails}>
                    <div className="sectionTitle">
                      <h4>Member Info</h4>
                    </div>
                    <div ref={memberdetails}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">
                            Member & Policy Details
                          </h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={4} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Member ID"
                            value={memberId}
                            attrName={setMemberId}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>

                        <Grid xs={6} md={6} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Client ID"
                            value={clientId}
                            attrName={setclientId}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={4} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Policy ID"
                            value={policyId}
                            attrName={setpolicyId}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={4} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Policy Number"
                            value={policyNumber}
                            attrName={setpolicyNumber}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>

                  <Box className="detailSection" ref={hospitalDetails}>
                    <div className="sectionTitle">
                      <h4>Hospital/Treatment/Claim Info</h4>
                    </div>
                    <div ref={basicdetails}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Basic Details</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Hospital"
                            value={hospital}
                            attrName={setHospital}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>

                        <Grid xs={6} md={6} lg={3}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="Country"
                            value={country}
                            attrName={setCountry}
                            value_update={updateMasterState}
                            data={country_data}
                            warn_status={false}
                            error_message="Please select country"
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="State"
                            value={state}
                            attrName={setState}
                            value_update={updateMasterState}
                            data={state_data}
                            warn_status={false}
                            error_message="Please select state"
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <SearchDropdownDisable
                            class_name="inputField"
                            title="City"
                            value={city}
                            attrName={setCity}
                            value_update={updateMasterState}
                            data={city_data}
                            warn_status={false}
                            error_message="Please select city"
                          />
                        </Grid>
                        <Grid sm={6} md={5} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Department"
                            value={department}
                            attrName={setDepartment}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <DatePicker
                            class_name="inputField"
                            title="Admission Date"
                            value={admissionDate}
                            attrName={setAdmissionDate}
                            value_update={updateMasterState}
                            error_message="Please enter admission date"
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <DatePicker
                            class_name="inputField"
                            title="Discharge Date"
                            value={dischargeDate}
                            attrName={setDischargeDate}
                            value_update={updateMasterState}
                            error_message="Please enter admission date"
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Illness Reason for Hospitalisation/Claim"
                            value={illness}
                            attrName={setIllness}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid
                          xs={12}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <div className="Checkbox">
                            <input type="checkbox" name="check" checked />
                            <label className="employee"></label>
                          </div>
                          <h5 className="mb-0">
                            If it is a legal case, kindly submit the FIR Report
                          </h5>
                        </Grid>
                      </Grid>
                    </div>
                  </Box>
                  <Box className="detailSection" ref={claimInfo}>
                    <div className="sectionTitle">
                      <h4>Claim Info</h4>
                    </div>
                    <div ref={claimdetails}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Claim Details</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Requested Claim Amount"
                            value={claimamount}
                            attrName={setClaimAmount}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Paid Claim Amount"
                            value={paidclaimamount}
                            attrName={setPaidClaimAmount}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Outstanding Claim Amount"
                            value={outstandingclaimamount}
                            attrName={setOutstandingClaimAmount}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Transaction ID"
                            value={transactionId}
                            attrName={setTransactionId}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Bank Name"
                            value={bankName}
                            attrName={setBankName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Branch Name"
                            value={branchName}
                            attrName={setBranchName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={6} lg={3}>
                          <RKTextFieldDisable
                            class_name="inputField"
                            title="Remarks"
                            value={remarks}
                            attrName={setRemarks}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>

                  <Box className="detailSection" ref={attatchmentsdetails}>
                    <div className="sectionTitle">
                      <h4>Bills & Attachments </h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add Document
                        </Link>
                      </div>
                    </div>
                    <Attachment
                      open_status={attachment}
                      attrName={setAttachment}
                      value_update={updateMasterState}
                    />
                  </Box>
                </>
              ) : null}

              {viewTabsStatus == "notes" ? (
                <>
                  <Box className="detailSection">
                    <div className="sectionTitle">
                      <h4>Notes</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setPostQueryForm(true);
                          }}
                        >
                          Add Notes
                        </Link>
                      </div>
                    </div>

                    <NotesSection data={notesData} />
                  </Box>
                </>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      <PostQueryForm
        attrName={setPostQueryForm}
        open_status={postQueryForm}
        value_update={updateMasterState}
      />

      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to Delete this Attatchment.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal open={removeStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setRemoveStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are want to remove this Claim.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}
export default ClaimAssistantDetailEmployer;
